"use client";

import React from "react";
import { cn } from "@/lib/utils";

interface QuestionListProps {
    questions: string[];
    title?: string;
    className?: string;
    circleColor?: string;
    lineColor?: string;
    textColor?: string;
}

const QuestionList: React.FC<QuestionListProps> = ({
    questions,
    title = "Question List",
    className = "",
    circleColor = "bg-brand-500",
    lineColor = "bg-brand-500",
    textColor = "text-black"
}) => {
    return (
        <div className={cn("w-full", className)}>
            {/* Title */}
            {title && (
                <h3 className={cn("font-bold mb-4", textColor)}>
                    {title}
                </h3>
            )}

            {/* Questions List */}
            <div className="relative">
                {questions.map((question, index) => (
                    <div key={index} className="flex items-start mb-4 last:mb-0">
                        {/* Circle with number */}
                        <div className="flex-shrink-0 mr-4 relative">
                            <div className={cn(
                                "w-8 h-8 rounded-full flex items-center justify-center text-white font-medium text-sm",
                                circleColor
                            )}>
                                {index + 1}
                            </div>

                            {/* Connecting line - only show if not the last item */}
                            {index < questions.length - 1 && (
                                <div className={cn(
                                    "absolute left-1/2 top-8 w-0.5 h-6 -translate-x-1/2",
                                    lineColor
                                )} />
                            )}
                        </div>

                        {/* Question text */}
                        <div className={cn("flex-1 pt-1 text-xs", textColor)}>
                            {question}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuestionList; 